import React, {useState, useEffect, useContext} from 'react'
import { observer } from 'mobx-react-lite'
import { ArrowRight } from 'react-bootstrap-icons'
import InsightForm from './InsightSidebarParts/InsightForm'
import axiosService from '../../../../../../utils/AxiosService'
import InsightUpload from '../../../../../../models/InsightUpload'
import { useParams } from 'react-router-dom'

export default observer(function InsightsSidebar({ onClose, insight }) {
  const { id } = useParams()

  const getInsightUploads = () => {
    axiosService.get(`/api/project_manager/campaigns/${id}/actions/${insight.action_id}/action_insights/${insight.id}/insight_uploads`)
    .then(uploads => {
      insight.insight_uploads = uploads.map(upload => new InsightUpload(upload))
    })
    .catch(error => {
      console.log(error)
    })
  }

  useEffect(() => {
    getInsightUploads()
  }, [])

  return (
    <div className='fixed top-0 right-0 w-[440px] h-full bg-white dark:bg-rb-dark-mode z-50 flex flex-col shadow-[-4px_0_10px_-1px_rgba(0,0,0,0.1)] overflow-y-auto'>
      <div className='pt-[52px] h-full flex flex-col'>
        <div className="p-4 px-6 flex justify-between items-center">
          <h2 className='font-bold text-lg dark:text-white'>Action insights</h2>
          <button className='flex gap-1 items-center p-2 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white'>
            <span
              className="font-bold"
              onClick={onClose}
            >Back</span>
            <ArrowRight className='text-lg'/>
          </button>
        </div>

        <div className='h-72 w-full pb-4 px-6'>
          <InsightForm insight={insight} />
        </div>

        {/* <div>
          <InsightUploadSelectPanel />
        </div> */}

      </div>
    </div>
  )
})